import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoginPromoModal from '../../../../components/modal/login-promo';
import ProductAlertForm from '../product-alert-form';
import ProductAlertInfo from '../product-alert-info';
import actions from '../../../sidebar/actions/alert';

class CreateAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoginPromo: false,
    };
  }

  render() {
    const {
      product,
      account,
      sending,
      error,
      createAlertRequest,
      removeAlertRequest,
      privacyPolicyUri,
      showCancel,
      onCreate,
      onRemove,
      withoutGraph,
    } = this.props;
    return (
      <React.Fragment>
        <LoginPromoModal
          isOpen={this.state.showLoginPromo}
          onRequestClose={() => this.setState({ showLoginPromo: false })}
        />
        <ProductAlertInfo product={product} />
        <ProductAlertForm
          product={product}
          disabled={sending}
          error={error}
          onCreate={productAlert => createAlertRequest(productAlert, onCreate)}
          onRemove={id => removeAlertRequest(id, product.id, onRemove)}
          useEmail={!account || !account.isAuthenticated}
          privacyPolicyUri={privacyPolicyUri}
          showCancel={showCancel}
          shouldAutoFocus
          openLoginPromo={() => this.setState({ showLoginPromo: true })}
          withoutGraph={withoutGraph}
        />
      </React.Fragment>
    );
  }
}

const { func, object, bool, shape, string, oneOfType } = PropTypes;

CreateAlert.propTypes = {
  product: object, // eslint-disable-line react/forbid-prop-types
  createAlertRequest: func.isRequired,
  removeAlertRequest: func.isRequired,
  sending: bool,
  error: oneOfType([bool, string]),
  account: shape({ me: object, isAuthenticated: bool }),
  privacyPolicyUri: string,
  showCancel: bool,
  onCreate: func,
  onRemove: func,
};

CreateAlert.defaultProps = {
  product: undefined,
  account: undefined,
  privacyPolicyUri: undefined,
  showCancel: true,
  onCreate: () => {},
  onRemove: () => {},
  sending: false,
  error: false,
};

export default connect(
  state => ({
    account: state.areas.account,
    sending: state.areas.productAlert.sending,
    error: state.areas.productAlert.error,
  }),
  actions
)(CreateAlert);
